import { ClipboardList } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { WarehouseIncidentsPage } from './pages/WarehouseIncidentsPage'
import { WarehouseIncidentPage } from './pages/WarehouseIncidentPage'

export default defineModule({
  id: 'warehouse-incidents',
  name: 'Incident Reports',
  shortName: 'Incidents',
  icon: ClipboardList,
  navSection: 'warehouse',
  navOrder: 10,
  urlNamespace: '/warehouse-incidents',
  routes: [
    { path: '/', element: WarehouseIncidentsPage, label: 'Incident Reports' },
    { path: '/new', element: WarehouseIncidentPage, label: 'New Report' },
    { path: '/$reportId', element: WarehouseIncidentPage, label: 'Incident Report' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing', 'warehouse'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g k',

  commandPaletteEntries: [
    {
      label: 'Go to Incident Reports',
      keywords: ['incident', 'accident', 'damage', 'warehouse', 'report', 'wir'],
      path: '/',
      group: 'modules',
      shortcut: 'g k',
    },
    {
      label: 'New Incident Report',
      keywords: ['new incident', 'file report', 'new report', 'damage report'],
      path: '/new',
      group: 'actions',
    },
  ],
})
